import React, { useEffect, useState } from "react";
import { TableRow, TableCell, Stack, Typography } from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedSite } from "../../../../../../features/forecastersSlice";
import MetricsByMonthDialogue from "../../ForeCasterInfo/MetricsByMonth/MetricsByMonth";

interface Props {
  NonEditableMonths: any;
  isMonthPassed: any;
  formatNumber: any;
}

export const NonEditableProfit = ({ NonEditableMonths, isMonthPassed, formatNumber }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const selectedSiteFromRedux = useSelector((state: any) => state.forecasters?.selectedSite);
  const selectedSiteFromURL = searchParams.get("selectedSite");
  const selectedSite = selectedSiteFromRedux || selectedSiteFromURL;

  useEffect(() => {
    const newSearchParams = new URLSearchParams(location.search);
    if (
      location.pathname === "/assets/overview/forecaster/forecasterInfo" &&
      newSearchParams.get("page") !== "0"
    ) {
      newSearchParams.set("page", "0");
      navigate(`${location.pathname}?${newSearchParams.toString()}`, {
        replace: true,
      });
    }
  }, [location.search, location.pathname, navigate]);

  // Ensure selectedSite is set in Redux store when component mounts
  useEffect(() => {
    if (selectedSite && !selectedSiteFromRedux) {
      dispatch(setSelectedSite(selectedSite));
    }
  }, [selectedSite, selectedSiteFromRedux, dispatch]);

  const [openMetrics, setOpenMetrics] = useState(false);

  const handleClose = () => {
    setOpenMetrics(false);
  };

  const formatPercentage = (value: any): string => {
    const num = Number(value);
    return isNaN(num) ? "0%" : `${Math.round(num * 100)}%`;
  };
  return (
    <>
      {NonEditableMonths?.map((row: any, rowIndex: any) => (
        <>
          <React.Fragment key={rowIndex}>
            <TableRow
              sx={{
                backgroundColor: isMonthPassed(row.month) ? "#F5F5F5" : "#FFFFFF",
                "& > *": {
                  borderBottom: "1px solid rgba(224, 224, 224, 1) !important",
                },
                height: 35,
              }}
            >
              <TableCell
                align="left"
                sx={{
                  backgroundColor: "#ffffff",
                  padding: "0px 8px !important",
                  position: "sticky",
                  left: 0,
                  zIndex: 2,
                }}
              >
                <Stack direction="row" alignItems="center" gap={0.5}>
                  <Typography variant="body2" color='secondary'>(A)</Typography>
                  <Typography variant="body2" color='secondary' component="span">{row.displayMonth}</Typography>
                </Stack>
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#ffffff",
                  padding: "0px 8px !important",
                  position: "sticky",
                  left: "109px",
                  zIndex: 2,
                }}
              >
                {row?.nrpu ? `${Math.round(parseFloat(row.nrpu))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#FFFFFF",
                  padding: "0px 8px !important",
                  position: "sticky",
                  left: "196px",
                  zIndex: 2,
                }}
              >
                {row?.ftd ? formatNumber(parseFloat(row.ftd)) : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#ffffff",
                  padding: "0px 8px !important",
                  position: "sticky",
                  left: "272px",
                  zIndex: 2,
                }}
              >
                {row?.avg_net_rev_per_active_user ? `${formatNumber(parseFloat(row.avg_net_rev_per_active_user))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#ffffff",
                  padding: "0px 8px !important",
                  position: "sticky",
                  left: "502px",
                  zIndex: 2,
                }}
              >
                {row?.cpa_pv ? `${formatNumber(parseFloat(row.cpa_pv))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#ffffff",
                  padding: "0px 8px !important",
                  position: "sticky",
                  left: "600px",
                  zIndex: 2,
                }}
              >
                {formatNumber(row.cvr * 100)}%
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#ffffff",
                  padding: "0px 8px !important",
                  position: "sticky",
                  left: "678px",
                  zIndex: 2,
                  borderRight: "1px solid #e0e0e0",
                }}
              >
                {row?.cac ? `${formatNumber(parseFloat(row.cac))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.active_users ? formatNumber(parseFloat(row.active_users)) : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.old_active_users ? formatNumber(parseFloat(row.old_active_users)) : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.acquired_active_users ? formatNumber(parseFloat(row.acquired_active_users)) : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.growth_target ? `${Math.round(parseFloat(row.growth_target) * 100)}%` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.net_revenue ? `${formatNumber(parseFloat(row.net_revenue))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.rs ? `${formatNumber(parseFloat(row?.rs))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.rs_pv ? `${formatNumber(parseFloat(row?.rs_pv))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.cpa ? `${formatNumber(parseFloat(row?.cpa))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.total_income ? `${formatNumber(parseFloat(row?.total_income))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.clicks ? `${Math.round(parseFloat(row.clicks))}` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.epc_cpa ? `${formatNumber(parseFloat(row.epc_cpa))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.epc_rs ? `${formatNumber(parseFloat(row.epc_rs))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.epc ? `${formatNumber(parseFloat(row.epc))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.cpc ? `${formatNumber(parseFloat(row.cpc))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {formatNumber(row.profit)}$
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: "#F5F5F5",
                  padding: "0px 8px !important",
                }}
              >
                {row?.spend ? `${formatNumber(parseFloat(row.spend))}$` : ""}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: isMonthPassed(row.month) ? "#F5F5F5" : "#FFFFFF",
                  padding: "0px 8px !important",
                }}
              >
                {formatPercentage(row?.avg_rs_deal_p)}
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: isMonthPassed(row.month) ? "#F5F5F5" : "#FFFFFF",
                  padding: "0px 8px !important",
                }}
              >
                {Math.round(Number(row?.churn_rate) * 100)}%
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: isMonthPassed(row.month) ? "#F5F5F5" : "#FFFFFF",
                  padding: "0px 8px !important",
                }}
              >
                {Math.round(Number(row?.br_to_ng_active_rs_ratio) * 100)}%
              </TableCell>
              <TableCell
                align="center"
                data-tracker="131"
                sx={{
                  backgroundColor: isMonthPassed(row.month) ? "#F5F5F5" : "#FFFFFF",
                  padding: "0px 8px !important",
                }}
              >
                {Math.round(Number(row?.ratio_between_acquired_to_ftd) * 100)}%
              </TableCell>
            </TableRow>
          </React.Fragment>
          <MetricsByMonthDialogue
            open={openMetrics}
            handleClose={handleClose}
            selectedSiteFromParent={selectedSite}
          />
        </>
      ))}
    </>
  )
}

